// src/components/enduser/layout/EnduserLayout.tsx

import React, { useState, useEffect } from "react";
import { mountGoogleTranslate } from "../../../utils/googleTranslate";
import { Outlet, Link, useLocation, useNavigate } from "react-router-dom";
import { useEnduserAuth } from "../../../contexts/EnduserAuthContext";
const EnduserLayout: React.FC = () => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const { logout } = useEnduserAuth();

  // Google Translate - fixed version
  // בורר השפות. הלוגיקה רוכזה ב-utils/googleTranslate: קודם כל קומפוננטה
  // טענה את הסקריפט בעצמה ומחקה את של האחרות, מה שגרם ל-element.js לרוץ
  // פעמיים ולהישבר. עכשיו הוא נטען פעם אחת בלבד בחיי הדף.
  useEffect(
    () =>
      mountGoogleTranslate("google_translate_element"),
    []
  );

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const menuItems = [
    {
      label: "דשבורד",
      path: "/enduser/dashboard",
      icon: "🏠",
    },
    {
      label: "אודות",
      path: "/about",
      icon: "ℹ️",
    },
    {
      label: "אנשי קשר מומלצים",
      path: "/recommended-contacts",
      icon: "📞",
    },
    // {
    //   label: "מחשבונים",
    //   path: "/enduser/calculators",
    //   icon: "🧮",
    // },
    {
      label: "החישובים שלי",
      path: "/enduser/history",
      icon: "📊",
    },
    {
      label: "הסברי חישוב",
      path: "/enduser/explanations",
      icon: "❓",
    },
    {
      label: "אזור אישי",
      path: "/enduser/profile",
      icon: "👤",
    },
    {
      label: "תנאי שימוש ופרטיות",
      path: "/terms-and-privacy",
      icon: "📋",
    },
    {
      label: "הצהרת נגישות",
      path: "/accessibility-statement",
      icon: "♿",
    },
  ];

  return (
    <div className="min-h-screen bg-gray-100 flex flex-col" dir="rtl">
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-200 fixed top-0 left-0 right-0 z-40">
        {" "}
        <div className="flex items-center justify-between px-4 py-3">
          {/* Logo & Menu Button */}
          <div className="flex items-center space-x-4 space-x-reverse">
            <button
              onClick={toggleSidebar}
              className="p-2 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
              aria-label="פתח תפריט ניווט"
            >
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M4 6h16M4 12h16M4 18h16"
                />
              </svg>
            </button>
            <Link to="/enduser/dashboard">
              <h1 className="text-xl font-bold text-blue-600">CarTax</h1>
            </Link>
          </div>

          {/* Right side - Google Translate positioned to the right */}
          <div className="flex items-center justify-end">
            <div
              id="google_translate_element"
              className="google-translate-container"
            ></div>
          </div>
        </div>
      </header>

      <div className="flex pt-16">
        {/* Sidebar */}
        <div
          className={`fixed top-0 bottom-0 right-0 z-50 w-64 bg-white shadow-lg transform transition-transform duration-300 ease-in-out ${
            isSidebarOpen ? "translate-x-0" : "translate-x-full"
          }`}
        >
          <div className="flex flex-col h-full">
            {/* Sidebar header */}
            <div className="flex items-center justify-between p-4 border-b">
              <h2 className="text-lg font-semibold text-gray-800">תפריט</h2>
              <button
                onClick={toggleSidebar}
                className="p-1 rounded-md text-gray-600 hover:text-gray-900 hover:bg-gray-100"
                aria-label="סגור תפריט ניווט"
              >
                <svg
                  className="h-5 w-5"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M6 18L18 6M6 6l12 12"
                  />
                </svg>
              </button>
            </div>

            {/* Menu items */}
            <nav className="flex-1 px-4 py-6 space-y-2 overflow-y-auto">
              {menuItems.map((item) => (
                <Link
                  key={item.label}
                  to={item.path}
                  onClick={toggleSidebar}
                  // target={item.openInNewTab ? "_blank" : undefined}
                  // rel={item.openInNewTab ? "noopener noreferrer" : undefined}
                  className={`flex items-center space-x-3 space-x-reverse px-3 py-2 rounded-md transition-colors ${
                    location.pathname === item.path
                      ? "bg-blue-100 text-blue-700"
                      : "text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  <span className="text-lg">{item.icon}</span>
                  <span>{item.label}</span>
                </Link>
              ))}
            </nav>

            {/* Sidebar footer */}
            <div className="p-4 border-t">
              <button
                onClick={() => {
                  logout(); // ✅ מוחק טוקן + מנקה state
                  navigate("/enduser/login");
                  toggleSidebar();
                }}
                className="w-full text-right text-sm text-red-600 hover:text-red-700 py-2"
                aria-label="לחצן ליציאה מהמערכת"
              >
                יציאה מהמערכת
              </button>
            </div>
          </div>
        </div>

        {/* Overlay */}
        {isSidebarOpen && (
          <div
            className="fixed inset-0 bg-black bg-opacity-50 z-40"
            onClick={toggleSidebar}
          ></div>
        )}

        {/* Main content */}
        <main className="flex-1 min-h-screen">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default EnduserLayout;
